import { useMediaQuery, useTheme } from "@mui/material";
import { useCompanyConfigQuery } from "../../../SWR/Company/useCompanyConfigQuery";
import { APP_CONTAINER_MAX_WIDTH_DESKTOP, APP_CONTAINER_MAX_WIDTH_MOBILE, APP_CONTAINER_PADDING_DESKTOP, APP_CONTAINER_PADDING_MOBILE, } from "./useContainerSettings-utils";
/**
 * Creating a hook to determine the container width based on the device size
 * ensures that the same container width is used across the entire app.
 * @returns UseContainerWidthReturn
 */
export const useContainerSettings = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { openedFromMobileApp } = useCompanyConfigQuery();
    return isMobile
        ? {
            containerPadding: APP_CONTAINER_PADDING_MOBILE,
            containerWidth: APP_CONTAINER_MAX_WIDTH_MOBILE,
            isMobile: isMobile,
            openedFromMobileApp: openedFromMobileApp,
        }
        : {
            containerPadding: APP_CONTAINER_PADDING_DESKTOP,
            containerWidth: APP_CONTAINER_MAX_WIDTH_DESKTOP,
            isMobile: isMobile,
            openedFromMobileApp: openedFromMobileApp,
        };
};
